import { Signal } from '@preact/signals';

export const startedListener = (videoStarted: Signal<boolean>, videoPlaying: Signal<boolean>) => {
  videoStarted.value = true;
  videoPlaying.value = true;
};
